import { postAction } from '../core/http.js';
import { morphInner, morphElement } from '../core/morph.js';
import { emit } from '../core/bus.js';
import { destroySpinners } from '../components/QuantitySpin.js';
import { getReadyFragments } from '../net/prefetcher.js';

function getVisiblePickupPointSelection() {
    const $inpostContainer = $('.js-inpost-shipping-container:visible').first();

    if ($inpostContainer.length) {
        const address = $inpostContainer.find('.js-inpost-shipping-machine-address').text().trim();
        const locker = $inpostContainer.find('.js-inpost-shipping-input').val();

        return {
            $container: $inpostContainer,
            value: address || (locker ? String(locker).trim() : ''),
        };
    }

    const $gmParcelLocker = $('.gmparcellocker-button:visible').first();

    if ($gmParcelLocker.length) {
        const parcel = $gmParcelLocker.find('.chosen-parcel').text().trim();

        return {
            $container: $gmParcelLocker,
            value: parcel !== '---' ? parcel : '',
        };
    }

    return {
        $container: $(),
        value: '',
    };
}

class Checkout {
    constructor() {
        this.selectors = {
            classCheckoutWrapper: '.js-checkout-wrapper',

            buttonClearCart: '.js-clear-cart',
            buttonShowDeliveryAddressForm: '.js-show-delivery-address-form',
            buttonShowInvoiceAddressForm: '.js-show-invoice-address-form',
            buttonShowEditForm: '.js-show-edit-form',
            buttonCancelEdit: '.js-cancel-edit',

            buttonsSelectGift: '.js-select-gift',

            inputCarrier: '[name="id_carrier"]',
            inputCountry: '[name="id_country"]',
            inputPayment: '[name="id_payment"]',
            inputService: '[name="service"]',

            inputMessage: '[name="message"]',

            inputIsInvoiceDifferentAddress: '[name="is_invoice_different_address"]',
            inputIsPaperInvoice: '[name="invoice_paper"]',
            inputIsLanguageInvoice: '[name="invoice_language"]',
            inputIsInvoicePersonal: '[name="invoice_personal"]',

            buttonAddressDelete : '.js-checkout-address-delete',
            buttonAddressEdit : '.js-checkout-address-edit',
            buttonAddressInvoiceEdit : '.js-checkout-invoice-address-edit',

            inputAddressDelivery: '[name="id_address_delivery"]',
            inputAddressInvoice: '[name="id_address_invoice"]',

            inputTerms: '[name="term[]"]',

            buttonGenerateLink: '.js-generate-cart-link',
            formProceed: '.js-proceed-section',
            buttonProceed: '.js-checkout-confirmation',
            sectionCheckout: '.checkout-section',
            sectionAuth: '.checkout-section-auth',
            sectionAddressDelivery: '.checkout-section-address-delivery',
            sectionAddressBilling: '.checkout-section-address-billing',
            sectionDelivery: '.checkout-section-delivery',
            sectionPayment: '.checkout-section-payment',

            inputQuantitySpin: '[name="product-quantity-spin"]',

            classBodyLoader: 'js-checkout-refresh',
            loaderOverlay: '.st-checkout-loader',

            buttonGusFetch: '.js-gus-fetch',
        }

        this.initCheckout();
        this.handleCheckoutEvents();
        this.handlePrestaShopEvents();
    }

    formatGusStreetAddress(data) {
        if (!data) {
            return '';
        }

        const street = (data.street || '').trim();
        const propertyNumber = (data.propertyNumber || '').trim();
        const apartmentNumber = (data.apartmentNumber || '').trim();

        let numberPart = '';
        if (propertyNumber && apartmentNumber) {
            numberPart = `${propertyNumber}/${apartmentNumber}`;
        } else if (propertyNumber) {
            numberPart = propertyNumber;
        } else if (apartmentNumber) {
            numberPart = apartmentNumber;
        }

        return [street, numberPart].filter(Boolean).join(' ').trim();
    }

    initCheckout() {
    }

    getProceedButton() {
        return $(this.selectors.buttonProceed).first();
    }

    getFirstVisibleConfirmSection() {
        const $confirmButton = $('.js-confirm-data:visible').first();

        if (!$confirmButton.length) {
            return $();
        }

        return $confirmButton.closest(this.selectors.sectionCheckout);
    }

    getBlockingSection() {
        const $confirmSection = this.getFirstVisibleConfirmSection();
        if ($confirmSection.length) {
            return $confirmSection;
        }

        if (!$(this.selectors.inputAddressDelivery + ':checked').length) {
            return $(this.selectors.sectionAddressDelivery).first();
        }

        if (
            $(this.selectors.inputIsInvoiceDifferentAddress).is(':checked') &&
            !$(this.selectors.inputAddressInvoice + ':checked').length
        ) {
            return $(this.selectors.sectionAddressBilling).first();
        }

        const pickupPoint = getVisiblePickupPointSelection();
        if (pickupPoint.$container.length && !pickupPoint.value) {
            return pickupPoint.$container.closest(this.selectors.sectionCheckout);
        }

        if (!$(this.selectors.inputCarrier + ':checked').length) {
            return $(this.selectors.sectionDelivery).first();
        }

        if (!$(this.selectors.inputPayment + ':checked').length) {
            return $(this.selectors.sectionPayment).first();
        }

        return $();
    }

    getBlockedProceedMessage($button = this.getProceedButton()) {
        const proceedError = $button.attr('data-proceed-error');
        if (proceedError) {
            return proceedError;
        }

        const inpostError = $('.js-inpost-danger').text().trim() || $('.js-inpost-warning').text().trim();
        if (inpostError) {
            return inpostError;
        }

        return '';
    }

    scrollToSection($section) {
        if (!$section.length) {
            return;
        }

        $section.get(0).scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    }

    handleBlockedProceed($button, errorMessage = '') {
        const $pendingConfirmationForm = this.getFirstPendingConfirmationForm();
        if ($pendingConfirmationForm.length) {
            this.showPendingConfirmationMessage($pendingConfirmationForm);
            return true;
        }

        const $blockingSection = this.getBlockingSection();
        const message = errorMessage || this.getBlockedProceedMessage($button);

        if (message) {
            $('.js-validation-error')
                .text(message)
                .show();

            if ($blockingSection.length) {
                this.showSectionValidationMessage($blockingSection, message);
            }
        }

        this.scrollToSection($blockingSection);

        return Boolean(message || $blockingSection.length);
    }

    handleCheckoutEvents() {
        $(document).on('click', this.selectors.buttonClearCart, () => {
            this.refresh('clearCart');
        });

        $(document).on('click', this.selectors.buttonShowDeliveryAddressForm, () => {
            this.refresh('refresh', {
                show_delivery_address_form: 1
            });
        });

        $(document).on('click', '.js-code', function(e) {
            const textToCopy = $(this).text();
            $('input[name="discount_name"]').val(textToCopy);
        });

        $(document).on('click', this.selectors.buttonShowInvoiceAddressForm, () => {
            this.refresh('refresh', {
                show_invoice_address_form: 1}
            );
        });

        $(document).on('click', this.selectors.buttonShowEditForm, (e) => {
            e.preventDefault();
            this.refresh('showEditForm', {
                show_edit_form: 1
            });
        });
        
        $(document).on('click', this.selectors.buttonCancelEdit, (e) => {
            e.preventDefault();
            this.refresh('refresh');
        });
        
        $(document).on('submit', 'form.auth-form', (e) => {
            e.preventDefault();
            const $form = $(e.currentTarget);
            // Guests must register (submitRegisterForm), logged-in customers edit (editCustomer).
            // The hidden action field is rendered server-side based on the login state.
            const formAction = $form.find('[name="action"]').val() || 'submitRegisterForm';

            postAction(formAction, $form.serialize()).then((parsedResponse) => {
                if (parsedResponse && parsedResponse.success) {
                    this.refresh('refresh');
                } else {
                    const $errors = $form.find('.js-form-errors');
                    $errors.empty();

                    if (parsedResponse && parsedResponse.errors && parsedResponse.errors.length) {
                        $errors.show();
                        const $errorList = $('<ul>');

                        parsedResponse.errors.forEach(error => {
                            $errorList.append($('<li>').text(error));
                        });

                        $errors.append($errorList);
                    }
                }
            });
        });

        $(document).on('change', this.selectors.inputCountry, (e) => {
            this.refresh('selectCountry', {
                id_country: $(e.target).val(),
            });
        });

        $(document).on('change', this.selectors.inputCarrier, (e) => {
            const id = $(e.target).val();
            this.optimisticSelect('carrier', id, { id_carrier: id }, 'selectCarrier');
        });

        $(document).on('change', this.selectors.inputPayment, (e) => {
            const id = $(e.target).val();
            this.optimisticSelect('payment', id, { id_payment: id }, 'selectPayment');
        });

        $(document).on('change', this.selectors.inputService, (e) => {
            e.preventDefault();
            this.refresh('selectService', {
                id_additional_service: $(e.target).val(),
            });
        });

        $(document).on('click', this.selectors.buttonsSelectGift, (e) => {
            this.refresh('selectGift', {
                id_checkout_gift: $(e.target).data('id-checkout-gift'),
            });
        });

        $(document).on('change', this.selectors.inputIsInvoiceDifferentAddress, (e) => {
            this.refresh('setInvoiceDifferentAddress', {
                is_invoice_different_address: $(e.target).is(':checked') ? 1 : 0,
            });
        });

        $(document).on('change', [this.selectors.inputIsPaperInvoice, this.selectors.inputIsLanguageInvoice].join(','), () => {
            this.refresh('setInvoiceType', {
                invoice_paper: $(this.selectors.inputIsPaperInvoice).is(':checked') ? 1 : 0,
                invoice_language: $(this.selectors.inputIsLanguageInvoice).is(':checked') ? 2 : 0,
            });
        });

        $(document).on('change', this.selectors.inputIsInvoicePersonal, () => {
            this.refresh('setInvoiceAddressPersonal', {
                invoice_personal: $(this.selectors.inputIsInvoicePersonal + ':checked').val(),
                show_invoice_address_form: 1,
            });
        });

        $(document).on('change', this.selectors.inputAddressDelivery, (e) => {
            this.refresh('setDeliveryAddress', {
                id_address_delivery: $(e.target).val(),
            });
        });

        $(document).on('change', this.selectors.inputAddressInvoice, (e) => {
            this.refresh('setInvoiceAddress', {
                id_address_invoice: $(e.target).val(),
            });
        });

        $(document).on('click', this.selectors.buttonAddressDelete, (e) => {
            e.stopPropagation();
            this.refresh('deleteAddress', {
                id_address: $(e.target).data('address-id'),
            });
        });

        $(document).on('click', this.selectors.buttonAddressEdit, (e) => {
            e.stopPropagation();
            this.refresh('refresh', {
                show_delivery_address_form: 1,
                id_address: $(e.target).data('address-id')
            });
        });

        $(document).on('click', this.selectors.buttonAddressInvoiceEdit, (e) => {
            e.stopPropagation();
            this.refresh('refresh', {
                show_invoice_address_form: 1,
                id_address: $(e.target).data('address-id')
            });
        });

        $(document).on('focusout', this.selectors.inputMessage, (e) => {
            $(e.target).closest('form').submit();
        });

        $(document).on('change', this.selectors.inputTerms, (e) => {
            let terms = [];
            $.each($(this.selectors.inputTerms + ':checked'), (index, term) => {
                terms.push($(term).val());
            });

            this.sendRequest('updateTerms', {
                terms: terms,
                }, (response) => {
            });
        });

        $(document).on('click', this.selectors.buttonGusFetch, (e) => {
            e.preventDefault();

            const nip = $('[name="vat_number"]').val();
            if (!nip) {
                alert('Please enter NIP number.');
            }

            this.sendRequest('getGusData', {
                nip: nip,
            }, (response) => {
                if (response.data !== undefined) {
                    $('[name="company"]').val(response.data.name);
                    $('[name="address1"]').val(this.formatGusStreetAddress(response.data));
                    $('[name="postcode"]').val(response.data.zipCode);
                    $('[name="city"]').val(response.data.city);
                } else if (response.error !== undefined) {
                    alert(response.error);
                }
            });
        });

        $(document).on('click', this.selectors.buttonGenerateLink, (e) => {
            e.preventDefault();
            this.sendRequest('generateLink', {}, (response) => {
                if (typeof response.link !== 'undefined') {
                    this.copyToClipboard(response.link);

                    alert('Link do koszyka został skopiowany do schowka');
                } else {
                    alert('Nie mozna wygenerować linku do koszyka.')
                }
            });
        });

        $(document).on('submit', '.address-form, .register-form, .login-form, .detail-form', (e) => {
            e.preventDefault();

            const $form = $(e.target);
            const data = $form.serialize();
            this.clearPendingConfirmationMessage($form);

            this.sendRequest('saveForm', data, (response) => {

                const $err = $form.find('.js-form-errors');

                $err.html('').hide();
                if (response.errors.length > 0) {

                    const $ul = $('<ul></ul>');
                    response.errors.forEach((error) => {
                        $ul.append($('<li></li>').text(error));
                    });
                    $err.html($ul).show();

                } else if (response.success) {
                    checkout.refresh();
                }
            });
        });

        $(document).on('submit', this.selectors.formProceed, (e) => {
            e.preventDefault(); 
            const $button = this.getProceedButton();
            if ($button.hasClass('disabled')) {
                this.handleBlockedProceed($button);

                return;
            }

            const newsletterChecked = $('#newsletter').is(':checked') ? 1 : 0;
            this.sendRequest('validateOrder', {
                newsletter: newsletterChecked
            }, (response) => {
                if (response.success) {
                    this.showLoader('order');
                    const selectedPaymentId = $('input[name="id_payment"]:checked').val();
                    if (selectedPaymentId) {
                        const paymentForm = $('.payment-form[data-payment-id="' + selectedPaymentId + '"]');

                        if (paymentForm.length) {
                            paymentForm.first().submit();
                        } else {
                            // Form-less option (e.g. tpay): its decorated form lives inside the
                            // selected option's extra block. Submit that if present; never fall
                            // back to an arbitrary other gateway's .payment-form.
                            const extraForm = $('.js-payment-extra[data-payment-id="' + selectedPaymentId + '"]').find('form').first();
                            if (extraForm.length) {
                                extraForm.submit();
                            }
                        }
                    }
                } else {
                    this.handleValidationErrors(response.errors);
                }
            });
        });

        $(document).on('click', this.selectors.buttonProceed, (e) => {
            const $button = $(e.currentTarget);
            const $pendingConfirmationForm = this.getFirstPendingConfirmationForm();

            if ($pendingConfirmationForm.length) {
                e.preventDefault();
                this.showPendingConfirmationMessage($pendingConfirmationForm);
                return;
            }

            if ($button.hasClass('disabled') || $button.attr('data-proceed-error')) {
                e.preventDefault();
                this.handleBlockedProceed($button);
            }
        });
    }

    handleValidationErrors(errors) {
        const messages = Array.isArray(errors) ? errors : [errors];
        const message = messages.filter(Boolean).join(' ');

        $('.js-validation-error').text(message).show();
        $('.js-checkout-section-alert').remove();

        const $targetSection = this.getValidationTargetSection(message);
        if ($targetSection.length) {
            this.showSectionValidationMessage($targetSection, message);
            this.scrollToElement($targetSection);
        }
    }

    getValidationTargetSection(message) {
        const normalizedMessage = String(message || '').toLowerCase();
        const hasAny = (patterns) => patterns.some((pattern) => normalizedMessage.indexOf(pattern) !== -1);

        if (hasAny(['logged', 'zalog'])) {
            return $('.checkout-section-auth').first();
        }

        if (hasAny(['invoice address', 'adres faktur'])) {
            const $invoiceSection = $('.checkout-section-address-billing').first();
            return $invoiceSection.length ? $invoiceSection : $('.checkout-section-address-delivery').first();
        }

        if (hasAny(['delivery address', 'adres dostaw'])) {
            return $('.checkout-section-address-delivery').first();
        }

        if (hasAny(['shipping method', 'carrier', 'metod dostaw', 'dostaw'])) {
            return $('.checkout-section-delivery').first();
        }

        if (hasAny(['payment method', 'payment', 'płat', 'plat'])) {
            return $('.checkout-section-payment').first();
        }

        if (hasAny(['cart is empty', 'koszyk'])) {
            return $('.checkout-section-cart-products').first();
        }

        return $('.js-proceed-section').first();
    }

    showSectionValidationMessage($section, message) {
        let $alert = $section.find('.js-checkout-section-alert').first();

        if (!$alert.length) {
            $alert = $('<div class="alert alert-danger js-checkout-section-alert mb-3" role="alert"></div>');

            const $cardBody = $section.find('.card-body').first();
            if ($cardBody.length) {
                $cardBody.prepend($alert);
            } else {
                $section.prepend($alert);
            }
        }

        $alert.text(message).show();
    }

    getFirstPendingConfirmationForm() {
        const $button = $('.js-confirm-data:visible').first();

        return $button.length ? $button.closest('form') : $();
    }

    showPendingConfirmationMessage($form) {
        const $button = $form.find('.js-confirm-data:visible').first();
        const buttonText = $.trim($button.text()) || 'Zatwierdź dane';
        const message = 'Kliknij "' + buttonText + '", aby zapisać uzupełnione dane w tej sekcji. Bez tego zamówienie nie przejdzie dalej.';
        const $section = $form.closest('.checkout-section');
        let $alert = $section.find('.js-confirm-data-alert').first();

        if (!$alert.length) {
            $alert = $('<div class="alert alert-danger js-confirm-data-alert mb-3" role="alert"></div>');
            const $formErrors = $form.find('.js-form-errors').first();

            if ($formErrors.length) {
                $alert.insertBefore($formErrors);
            } else {
                $form.prepend($alert);
            }
        }

        $alert.text(message).show();
        this.scrollToElement($section.length ? $section : $form);
        $button.trigger('focus');
    }

    clearPendingConfirmationMessage($form) {
        $form.closest('.checkout-section').find('.js-confirm-data-alert').remove();
    }

    scrollToElement($element) {
        if (!$element || !$element.length) {
            return;
        }

        const el = $element.get(0);
        if (!el) {
            return;
        }

        const top = Math.max(window.pageYOffset + el.getBoundingClientRect().top - 140, 0);
        window.scrollTo({ top, behavior: 'smooth' });
    }

    handlePrestaShopEvents() {
        prestashop.on(
            'updateCart',
            () => checkout.refresh()
        );
        
        this.checkAndSelectAddressRadios();
        $(document).on('change', this.selectors.inputIsInvoiceDifferentAddress, (e) => {
            if (!$(e.target).is(':checked')) {
                setTimeout(() => {
                    const firstInvoiceRadio = $(this.selectors.inputAddressInvoice).first();
                    if (firstInvoiceRadio.length) {
                        firstInvoiceRadio.click();
                    }
                }, 100);
            }
        });
    }

    applyFragments(fragments) {
        const added = [];
        const selectors = Object.keys(fragments);

        selectors.forEach((selector) => {
            const el = document.querySelector(selector);
            if (el) {
                morphInner(el, fragments[selector]).forEach((node) => added.push(node));
            }
        });

        prestashop.pageLazyLoad.update();
        if (prestashop.consentManager) {
            prestashop.consentManager.init();
        }
        this.checkAndSelectAddressRadios();
        toggleConfirmationButton();
        this.refreshStickySidebar();
        emit('fragment:applied', { mode: 'fragments', selectors, added });
    }

    refreshStickySidebar() {
        window.dispatchEvent(new Event('scroll'));
    }

    optimisticSelect(type, id, params, persistAction) {
        if (!this.latestSelection) {
            this.latestSelection = {};
        }
        this.latestSelection[type] = id;

        const fragments = getReadyFragments(type, id);

        if (!fragments) {
            this.refresh(persistAction, params);
            return;
        }

        this.applyFragments(fragments);

        postAction(persistAction, params)
            .then((response) => {
                if (this.latestSelection[type] !== id) {
                    return;
                }

                if (response && response.fragments) {
                    this.applyFragments(response.fragments);
                } else if (response && typeof response.content !== 'undefined' && response.content) {
                    this.refresh(persistAction, params);
                }
            })
            .catch(() => {});
    }

    refresh(action = 'refresh', data = {}) {
        this.sendRequest(action, data, (response) => {

            if (response.fragments && typeof response.fragments === 'object') {
                this.applyFragments(response.fragments);
            } else if (typeof response.content !== 'undefined' && response.content) {
                const wrapper = document.querySelector(this.selectors.classCheckoutWrapper);
                let added = [];

                if (wrapper) {
                    destroySpinners();
                    added = morphElement(wrapper, response.content);
                }

                prestashop.pageSlider.init();
                prestashop.pageLazyLoad.update();

                if (prestashop.consentManager) {
                    prestashop.consentManager.init();
                }

                this.checkAndSelectAddressRadios();
                toggleConfirmationButton();
                this.refreshStickySidebar();
                emit('fragment:applied', { mode: 'content', added });
            }

            if (typeof response.reload !== 'undefined' && response.reload) {
                location.reload();
            }

            this.hideLoader();
        }, () => {
            this.showLoader();
        }, (response) => {
            this.logeError(response);
            this.hideLoader();
        });
    }

    sendRequest(action, data, successCallback = function (){}, beforeSendCallback = function (){}, errorCallback = function (){}) {
        beforeSendCallback();

        postAction(action, data)
            .then((response) => {
                successCallback(response);
            })
            .catch((error) => {
                errorCallback(error);
            });
    }

    logeError(error) {
        console.log(error);
    }

    copyToClipboard(text) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).catch(() => this.copyToClipboardFallback(text));
            return;
        }

        this.copyToClipboardFallback(text);
    }

    copyToClipboardFallback(text) {
        const temp = document.createElement('textarea');
        temp.value = text;
        temp.setAttribute('readonly', '');
        temp.style.position = 'absolute';
        temp.style.left = '-9999px';
        document.body.appendChild(temp);
        temp.select();
        document.execCommand('copy');
        document.body.removeChild(temp);
    }

    showLoader(mode) {
        const overlay = document.querySelector(this.selectors.loaderOverlay);

        if (overlay) {
            const titleEl = overlay.querySelector('.js-loader-title');
            const subtitleEl = overlay.querySelector('.js-loader-subtitle');
            const title = mode === 'order' ? overlay.dataset.orderTitle : overlay.dataset.title;
            const subtitle = mode === 'order' ? overlay.dataset.orderSubtitle : overlay.dataset.subtitle;

            if (titleEl && title) {
                titleEl.textContent = title;
            }
            if (subtitleEl) {
                subtitleEl.textContent = subtitle || '';
            }
        }

        document.body.classList.add(this.selectors.classBodyLoader);
    }

    hideLoader() {
        document.body.classList.remove(this.selectors.classBodyLoader);
    }

    checkAndSelectAddressRadios() {
        const deliveryRadios = $(this.selectors.inputAddressDelivery);
        if (deliveryRadios.length && !deliveryRadios.is(':checked')) {
            deliveryRadios.first().click();
        }
        
        const invoiceRadios = $(this.selectors.inputAddressInvoice);
        if (invoiceRadios.length && !invoiceRadios.is(':checked')) {
            invoiceRadios.first().click();
        }
    }
}

let checkout = new Checkout();

$(document).on('click', '.st-radio-block', function() {
    $(this).find('input[type="radio"]').prop('checked', true).change();
});

$(document).on('click', '.select-block', function() {
    $(this).find('input[type="radio"]').prop('checked', true).change();
});

$(document).on('change', '[name="create_account"]', (e) => {
    const active = $(e.target).is(':checked');
    $('.form-group-passwd').toggleClass('d-none', !active);
    $('.form-group-industry').toggleClass('d-none', !active);
});

function toggleConfirmationButton() {
    const confirmDataVisible = $('.js-confirm-data').is(':visible');
    let disableButton = confirmDataVisible;
    const $button = $('.js-checkout-confirmation');
    const hasProceedError = Boolean($button.attr('data-proceed-error'));
    const pickupPoint = getVisiblePickupPointSelection();

    if (pickupPoint.$container.length && !pickupPoint.value) {
        disableButton = true;

        if (!$('.js-inpost-warning').length) {
            pickupPoint.$container.append('<div class="alert alert-warning js-inpost-warning mt-2 mx-2">Proszę wybrać Paczkomat</div>');
        }
        if (!$('.js-inpost-danger').length) {
            $button.before('<div class="alert alert-danger js-inpost-danger mt-2 mx-2 d-flex justify-content-center ml-auto w-100" style="max-width:275px;">Proszę wybrać Paczkomat</div>');
        }
    } else {
        $('.js-inpost-warning').remove();
        $('.js-inpost-danger').remove();
    }

    $button
        .prop('disabled', false)
        .toggleClass('disabled', disableButton || hasProceedError)
        .toggleClass('js-confirm-data-pending', confirmDataVisible)
        .attr('aria-disabled', disableButton || hasProceedError ? 'true' : 'false');
}

$(document).ready(function() {
    toggleConfirmationButton();
});

$(document).ajaxComplete(function() {
    toggleConfirmationButton();
});

$(document).on('inpost.locker.selected locker.change', function() {
    toggleConfirmationButton();
});
